<script>
  import Navbar from "../../../Shared/Navbar/index.svelte"
  import Footer from "../../../Shared/footer.svelte"
  import TextEditor from "../../Templates/Email/Shared/textEditor/index.svelte"
  import { sendEmail } from "../../Publish/BulkUpload/Script/bulkUpload"
  import { generateHTMLContent } from "../../../Script/generateHTMLContent"
  import { onMount } from "svelte"
  import { queryStringToJSON } from "../../../Script/queryString"
  import { push, querystring } from "svelte-spa-router"
  import ApplicationState from "../../../Stores/applicationStates"
  import notify from "../../../Script/notify"
  import axios from "axios"
  import EmailSelection from "./Components/emailSelection.svelte"
  import { fetchEmailTemplate } from "../../Publish/BulkUpload/Script/bulkUpload"
  import { flatenObject } from "../../../Script/flatenObject"
  import SuggestionModal from "../../Templates/Email/Edit/Modules/SuggestionModal/index.svelte"
  import LoadingScreen from "../../Publish/SinglePublish/Components/loadingScreen.svelte"
  import { parseInvalidAttributes } from "../../../Script/parseAttributes"
  import { fetchBadgeData } from "../../Publish/Badge/Script/api"
  import { getRequest } from "../../../Script/apiMethods"
  import he from "he"

  /**
   * @type {String} address to which the email to be send
   */
  let toAddress = ""
  /**
   * @type {String} subject of the mail
   */
  let emailSubject = ""
  /**
   * @type {String} default content to be displayed in the editor
   */
  let content = ""
  /**
   * @type {boolean} whether to disable send email button or not
   */
  let disableEmailBtn = false
  /**
   * @type {Object} stores the query value in an object
   */
  let query
  /**
   * @type {RegExp} regex pattern for validating the email address
   */
  let emailAddressPattern = /^[A-Z0-9.!#$%&'+/=?^_`{|}~-]+@[A-Z0-9-]+(?:\.[A-Z0-9-]+){1,}$/i
  /**
   * @typedef {Object} notification
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {notification}
   */
  let notification = {
    close() {},
  }
  /**
   * @typedef {Object} notificationSubject
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {notification}
   */
  let notificationSubject = {
    close() {},
  }
  /**
   * @typedef {Object} maxNotification
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {notification}
   */
  let maxNotification = {
    close() {},
  }
  /**
   * @typedef {Object} invalidNotification
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {notification}
   */
  let invalidNotification = {
    close() {},
  }
  /**
   * @typedef {Object} notificationSplChar
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {notification}
   */
  let notificationSplChar = {
    close() {},
  }
  /**
   * @typedef {Object} notificationURL
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {notification}
   */
  let notificationURL = {
    close() {},
  }

  let documentData = {}

  let parsedJson
  let baseURL
  let showEmailTemplateSelection = false
  let emailData = {
    headerType: "empty", //text
    headerText: "Test User",
  }
  let emailTempName = ""

  let showInvalidAttrModal = false

  let invalidAttributes = []

  let loading = false

  let loadtext = "Fetching Details"

  let qrSource = ""
  let copyEmails = []

  onMount(async () => {
    try {
      loading = true

      query = queryStringToJSON($querystring)
      // Redirect to the bulk publishing page if the "id" parameter is missing in the query
      if (!query.id) {
        push("/analytics/documents")
        return
      }

      const CONFIG = {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      }

      const data = await getRequest(`/api/swagger/v2/documents/${query.id}`, CONFIG)

      documentData = data.document

      if (query.aliasId) {
        const data = await getRequest(`/api/swagger/v2/links?documentID=${query.id}`, CONFIG)

        let aliasUrl = data.links

        aliasUrl = aliasUrl.filter((alias) => alias.id == query.aliasId)
        if (!aliasUrl.length) {
          const info = "PAGE: Compose Email\nEVENT: onMount - Alias URLs not found for the respective document ID."
          notification = notify.danger("No alias URL was found for your request.", info)
          push(`/documents/single/secure_access?id=${query.id}`)
          return
        }
        documentData.url = aliasUrl[0].url.split("id=")[1]
      }

      baseURL = $ApplicationState.viewBase.replace("/v2/", `/v${documentData.version}/`) + documentData.url

      if (query.aliasId) baseURL = baseURL.replace("/doc?", "/link?")

      toAddress = documentData.email ? documentData.email : ""

      content = `<p>Hi <strong>${documentData.recName}</strong><br><br>Your Blockchain secured document is available at <br>
        <a href="${baseURL}" target="_blank" rel="noreferrer" style="color:inherit; overflow-wrap: break-word;"><strong>${baseURL}</strong></a>
        </p>`

      if (query.badgeId) {
        // let badgedata = await fetchBadgeData(query.badgeId)
        // console.log(badgedata)

        let cspStatic = $ApplicationState.cspStatic ? $ApplicationState.cspStatic.replace("https://", "").split("/")[0] : ""
        // console.log({ cspStatic })

        let badgeBase = $ApplicationState.badgeBase.replace("https://", "").split("/")[0]
        // console.log({ badgeBase })

        let divTag = `<div class="p2b-badge" data-badge-src="${cspStatic || badgeBase}" data-badge-id="${query.badgeId}"></div>`
        // let scriptTag = "%3Cscript%20type%3D'module'%20src%3D'https%3A%2F%2Fprint2block.com%2Ftest-badge-v2%2Flink.js'%3E%3C%2Fscript%3E"
        // let scriptTag = "%3Cscript%20type%3D'module'%20src%3D'https%3A%2F%2Fprint2block.com%2Ftest-badge-v2%2Flink.js'%3E%3C%2Fscript%3E"

        let scriptTag = `%3Cscript%20type%3D"module"%20src%3D"https%3A%2F%2F${cspStatic || badgeBase}%2fbadge%2Flink.min.js"%3E%3C%2Fscript%3E`

        //     let csp = {
        //       "CSP Policy": `default-src 'self';
        // script-src 'wasm-unsafe-eval' 'self' https://print2block.com;
        // style-src 'self' https://print2block.com;
        // connect-src 'self' https://print2block.com;
        // form-action 'self' https://test.view.print2block.in;
        // object-src 'none';
        // base-uri 'self';
        // font-src 'self';
        // frame-ancestors 'none';
        // img-src 'self' https://test.view.print2block.in;
        // manifest-src 'self';
        // media-src 'self';
        // worker-src 'self' https://print2block.com;`,
        //       "HTML CSP Policy": `<meta
        //   http-equiv="Content-Security-Policy"
        //   content="
        // default-src 'self';
        // script-src 'wasm-unsafe-eval' 'self' https://print2block.com;
        // style-src 'self' https://print2block.com;
        // connect-src 'self' https://print2block.com;
        // form-action 'self' https://test.view.print2block.in;
        // object-src 'none';
        // base-uri 'self';
        // font-src 'self';
        // frame-ancestors 'none';
        // img-src 'self' https://test.view.print2block.in;
        // manifest-src 'self';
        // media-src 'self';
        // worker-src 'self' https://print2block.com;"
        // />`,
        //       "Nginx CSP Policy": `add_header Content-Security-Policy "default-src 'self';
        // script-src 'wasm-unsafe-eval' 'self' https://print2block.com;
        // style-src 'self' https://print2block.com;
        // connect-src 'self' https://print2block.com;
        // form-action 'self' https://test.view.print2block.in;
        // object-src 'none';
        // base-uri 'self';
        // font-src 'self';
        // frame-ancestors 'none';
        // img-src 'self' https://test.view.print2block.in;
        // manifest-src 'self';
        // media-src 'self';
        // worker-src 'self' https://print2block.com;"`,
        //     }

        cspStatic = cspStatic ? `https://${cspStatic}` : ""
        // console.log({ viewBase })

        badgeBase = `https://${badgeBase}`
        // console.log({ badgeBase })

        let viewBase = $ApplicationState.viewBase.replace("https://", "").split("/")[0]
        viewBase = `https://${viewBase}`
        // console.log({ viewBase })

        let csp = {
          "CSP Policy": `default-src 'self'; 
    script-src 'wasm-unsafe-eval' 'self' ${cspStatic || badgeBase};
    style-src 'self' ${cspStatic || badgeBase}; 
    form-action 'self' ${$ApplicationState.cspAPI || badgeBase || ""} ${viewBase};
    frame-ancestors 'none'; 
    img-src 'self' ${viewBase};
    connect-src 'self' ${cspStatic || badgeBase};`,

          "HTML CSP Policy": `<meta
    http-equiv="Content-Security-Policy"
    content="default-src 'self'; 
    script-src 'wasm-unsafe-eval' 'self' ${cspStatic || badgeBase};
    style-src 'self' ${cspStatic || badgeBase}; 
    form-action 'self' ${$ApplicationState.cspAPI || badgeBase || ""} ${viewBase};
    frame-ancestors 'none'; 
    img-src 'self' ${viewBase};
    connect-src 'self' ${cspStatic || badgeBase};"
    />`,

          "Nginx CSP Policy": `add_header Content-Security-Policy "default-src 'self'; 
    script-src 'wasm-unsafe-eval' 'self' ${cspStatic || badgeBase};
    style-src 'self' ${cspStatic || badgeBase}; 
    form-action 'self' ${$ApplicationState.cspAPI || badgeBase || ""} ${viewBase};
    frame-ancestors 'none'; 
    img-src 'self' ${viewBase};
    connect-src 'self' ${cspStatic || badgeBase};"`,
        }

        /**
         * @type {String} - active CSP content
         */
        let activeCSP = await convertToHTMLEntities(csp[query.cspPolicy])

        divTag = await convertToHTMLEntities(divTag)
        scriptTag = await convertToHTMLEntities(decodeURIComponent(scriptTag))

        content = `<p>Hi <strong>${documentData.recName}</strong></p><strong>Embed code in the ${await convertToHTMLEntities("<body>")} of your html</strong><br><div style="font-family: monospace; padding: 12px; background-color: ${!$ApplicationState.darkMode ? "#f7f7f7" : "rgb(64, 64, 64)"}; color: ${!$ApplicationState.darkMode ? "black" : "white"}; width: fit-content; border-radius: 6px;">${divTag}<br>${decodeURIComponent(scriptTag)}</div><br><strong>${query.cspPolicy}</strong><br><div style="font-family: monospace; padding: 12px; background-color: ${!$ApplicationState.darkMode ? "#f7f7f7" : "rgb(64, 64, 64)"}; color: ${!$ApplicationState.darkMode ? "black" : "white"}; width: fit-content; border-radius: 6px;">${activeCSP}</div><p>Thank you</p>`
      }

      documentData.metadata = JSON.parse(documentData.metadata)

      documentData.options = JSON.parse(documentData.options)

      parsedJson = { ...documentData.metadata, ...documentData.options, url: baseURL, documentID: query.id }
      if (parsedJson.expireOn) parsedJson.expireOn = new Date(parsedJson.expireOn).toDateString().slice(4)
      parsedJson.date = new Date(parsedJson.date).toDateString().slice(4)

      if (query.badgeId) delete parsedJson.url

      qrSource = `https://utils.print2block.in/qr/create/?size=120&data=${baseURL}`

      if (query.email) {
        emailData = await fetchEmailTemplate(query.email)

        emailTempName = emailData.name
        emailSubject = emailData.subject

        await replaceAttributes(emailData.content)
      }
    } catch (error) {
      notification.close()
      const info = "PAGE: Compose Email\nEVENT: onMount"
      notification = notify.danger(error, info)
    } finally {
      loading = false
    }
  })

  const convertToHTMLEntities = (inputString) => {
    return he.encode(inputString, { useNamedReferences: true })
  }

  const replaceLinkedInValues = async () => {
    try {
      const linkedInMatches = content.match(/\[\[(.*?)\]\]/g)

      if (linkedInMatches) {
        const linkedInValues = [...new Set(linkedInMatches.map((match) => match.slice(2, -2)))]

        let date = documentData.options.date

        for (let i = 0; i < linkedInValues.length; i++) {
          if (linkedInValues[i] == "cert_url") {
            let baseURL = $ApplicationState.viewBase.slice(0, $ApplicationState.viewBase.length - 1)
            content = content.replaceAll(`[[${linkedInValues[i]}]]`, `${baseURL}%3D${documentData.url}`)
          } else if (linkedInValues[i] == "cert_ID") {
            content = content.replaceAll(`[[${linkedInValues[i]}]]`, documentData.id)
          } else if (linkedInValues[i] == "document_type") {
            content = content.replaceAll(`[[${linkedInValues[i]}]]`, documentData.metadata.document["type"])
          } else if (linkedInValues[i] == "issue_Year") {
            content = content.replaceAll(`[[${linkedInValues[i]}]]`, new Date(date).getFullYear())
          } else if (linkedInValues[i] == "issue_Month") {
            content = content.replaceAll(`[[${linkedInValues[i]}]]`, new Date(date).getMonth() + 1)
          } else if (linkedInValues[i] == "expire_Year") {
            let value = documentData.options.expireOn ? new Date(documentData.options.expireOn).getFullYear() : ""
            content = content.replaceAll(`[[${linkedInValues[i]}]]`, value)
          } else if (linkedInValues[i] == "expire_Month") {
            let value = documentData.options.expireOn ? new Date(documentData.options.expireOn).getMonth() + 1 : ""
            content = content.replaceAll(`[[${linkedInValues[i]}]]`, value)
          }
        }
      }

      content = content.replaceAll("{{document_type}}", documentData.metadata.document["type"])
    } catch (error) {
      // console.error(error)
      throw error
    }
  }

  const sendTestEmail = async () => {
    try {
      if (!content.includes(baseURL) && !query.badgeId) throw "Please ensure the Document URL is added, as it appears to be missing."

      validateEmailDetails()

      replaceLinkedInValues()

      replaceAttributes(content)

      if (emailTempName) {
        // for replacing empty content inside curly brackets
        content = content.replaceAll(/\{\{\s*\}\}/g, "")

        invalidAttributes = Array.from(new Set(content.match(/(?<=\{\{).*?(?=\}\})/g)))

        if (invalidAttributes.length) {
          showInvalidAttrModal = true
          return
        }
      }

      disableEmailBtn = true
      let requestBody = {
        to: toAddress,
        subject: emailSubject,
        // content: generateHTMLContent(emailData, content),
        // content: generateHTMLMailContent(content),
        tag: `${documentData.id}::${documentData.issuerID}:SingleDocumentAnalytics`,
      }

      if (query.badgeId) requestBody.content = generateHTMLMailContent(content)
      else requestBody.content = generateHTMLContent(emailData, content)

      for (let i = 0; i < copyEmails.length; i++) {
        if (copyEmails[i].type == "Cc" && copyEmails[i].value) requestBody.cc = copyEmails[i].value
        if (copyEmails[i].type == "Bcc" && copyEmails[i].value) requestBody.bcc = copyEmails[i].value
      }

      loading = true

      loadtext = "Sending Email"

      await sendEmail(requestBody)

      notify.success("Email sent sucessfully.You will able to send mail after 10s if you needed.")
      setTimeout(() => {
        disableEmailBtn = false
      }, 10000)
    } catch (error) {
      notificationURL.close()
      console.error(error)
      const info = "PAGE: Compose Email\nEVENT: While sending test email"
      notificationURL = notify.danger(error, info)
      disableEmailBtn = false
    } finally {
      loading = false
      loadtext = "Fetching Details"
    }
  }

  const validateEmailDetails = () => {
    try {
      // if (!emailTempName) throw "Kindly Choose Email Template"
      if (!toAddress) throw "kindly Enter Email Address"

      let emails = toAddress.split(",")
      emails.forEach((value) => {
        if (!emailAddressPattern.test(value.trim())) throw "Enter a valid <strong>'To'</strong> email address"
      })
      // if (!emailAddressPattern.test(toAddress)) throw "Enter Valid Email address"
      if (copyEmails.length) {
        copyEmails.forEach((email) => {
          emails = email.value.split(",")
          emails.forEach((value) => {
            if (value.trim() && !emailAddressPattern.test(value.trim())) throw "Enter Valid <strong>'Cc or Bcc'</strong> Email address"
          })
        })
      }
      if (!emailSubject) throw "kindly Enter Email Subject"
      if (emailSubject && !emailSubject.trim()) throw "kindly Enter Email Subject"
    } catch (error) {
      throw error
    }
  }

  const checkEmptySubject = (subject) => {
    notificationSubject.close()
    if (!subject) {
      const info = "PAGE: Compose Email\nEVENT: onBlur - Email subject not found during validation."
      notificationSubject = notify.danger("Kindly Enter a subject for email", info)
    }
  }

  /**
   * @description  function to check not to exceed max characters
   */
  const exceedsmaxCharacters = () => {
    if (emailSubject.length > 70) {
      maxNotification.close()

      //returning values only in range below max characters
      setTimeout(() => {
        emailSubject = emailSubject.slice(0, 70)
      }, 100)

      maxNotification = notify.info(`Email subject should not be more than 70 characters`)
    }
  }

  /**
   * function to check for given pattern to template name
   * @param e - to capture key event
   */
  const checkSpecialCharsSubject = async (e) => {
    try {
      // Destructure the type and key properties from the event object
      let { type, key } = e

      // Regular expression to match allowed characters
      let allowedCharsRegex = /^[A-Za-z0-9\s-()+&.]+$/

      // Check if it's a keypress event and the pressed key is not allowed
      if (type === "keypress" && !allowedCharsRegex.test(key)) {
        e.preventDefault()

        emailSubject += key

        invalidNotification.close()

        // Prevent the default keypress behavior if the pressed key is not allowed
        // Show a danger notification indicating the allowed characters
        const info = "PAGE: Compose Email\nEVENT: Error during valid characters check in subject line during keypress."
        invalidNotification = notify.danger("Only letters, numbers, and special characters -()+&. are allowed.", info)
        setTimeout(() => {
          emailSubject = emailSubject.slice(0, -1)
        }, 100)
      } else if (type === "paste") {
        // Get the pasted text from the clipboard
        let clipboardData = e.clipboardData || window.clipboardData
        let pastedText = clipboardData.getData("text/plain")

        setTimeout(() => {
          notificationSplChar.close()
          // Check if the pasted text contains any invalid special characters
          if (!allowedCharsRegex.test(pastedText)) {
            // Remove any characters that are not allowed
            let sanitizedText = pastedText.replace(/[^A-Za-z0-9\s-()+&.]/g, "").trim()

            // Check if the sanitized text is the same as the original pasted text
            if (sanitizedText !== pastedText) {
              const info = "PAGE: Compose Email\nEVENT: Error during valid characters check in subject line during paste."
              notificationSplChar = notify.danger("Invalid special characters found. Only letters, numbers, and special characters -()+&. are allowed.", info)
            }

            // Set the input value to the sanitized text
            emailSubject = sanitizedText
          }
          exceedsmaxCharacters()
        }, 500)
      }
    } catch (error) {
      const info = "PAGE: Compose Email\nEVENT: Error during valid characters check in subject line during keypress / paste."
      notify.danger(error, info)
    }
  }

  const onEmailSelection = async (e) => {
    try {
      loading = true

      showEmailTemplateSelection = false

      emailData = await fetchEmailTemplate(e.detail)
      emailSubject = emailData.subject
      emailTempName = emailData.name

      await replaceAttributes(emailData.content)
    } catch (error) {
      const info = "PAGE: Compose Email\nEVENT: After email selection, error retrieving selected email template values."
      notify.danger(error, info)
    } finally {
      loading = false
    }
  }

  const replaceAttributes = async (emailContent) => {
    try {
      let flatObject = flatenObject(parsedJson)

      let flatObjectKeys = Object.keys(flatObject)

      // flatObjectKeys = flatObjectKeys.sort((a, b) => b.localeCompare(a))

      // for (let i = 0; i < flatObjectKeys.length; i++) {
      //   let key = flatObjectKeys[i]
      //   let value = flatObject[flatObjectKeys[i]]
      //   let regex = new RegExp(`{{\\s*${key}\\s*}(?!})`, "g") // Match `{{key}` but not `{{key}}`
      //   emailContent = emailContent.replaceAll(regex, `${value}`)

      //   // Match `{{key` without a closing brace
      //   let incompleteRegex = /{{\\s*${key}(?!\\s*}})/g
      //   emailContent = emailContent.replaceAll(incompleteRegex, `${value}`) // Add closing braces
      // }

      emailContent = parseInvalidAttributes(flatObjectKeys, emailContent)

      let unknownKeyRegex = /{{\s*([^}]+?)\s*}(?!})/g
      emailContent = emailContent.replaceAll(unknownKeyRegex, `{{$1}}`)

      let contentAttributes = Array.from(new Set(emailContent.match(/(?<=\{\{).*?(?=\}\})/g)))

      for (let i = 0; i < contentAttributes.length; i++) {
        if (flatObject[contentAttributes[i]]) {
          emailContent = emailContent.replaceAll(`{{${contentAttributes[i]}}}`, flatObject[contentAttributes[i]])
        }
      }

      emailContent = replaceQRSource(emailContent)
      content = emailContent
    } catch (error) {
      throw error
    }
  }

  const replaceQRSource = (emailContent) => {
    try {
      let div = document.createElement("div")
      div.innerHTML = emailContent

      let imageElem = div.querySelectorAll(".qr")

      for (let i = 0; i < imageElem.length; i++) {
        if (imageElem[i]) {
          let newImage = document.createElement("img")
          newImage.src = qrSource
          newImage.className = "qr"
          newImage.alt = "document-QR"
          newImage.style.width = "120px"

          imageElem[i].replaceWith(newImage)

          emailContent = div.innerHTML
        }
      }

      return emailContent
    } catch (error) {
      throw error
    }
  }

  const handleApplyContinue = async (e) => {
    try {
      let flatObject = flatenObject(parsedJson)

      for (const [key, value] of Object.entries(e.detail)) {
        content = content.replaceAll(`{{${key}}}`, flatObject[value])
      }
      showInvalidAttrModal = false
    } catch (error) {
      const info = "PAGE: Compose Email\nEVENT: Error occured while replacing invalid attributes."
      notify.danger(error, info)
    }
  }

  // let emailArea = null
  // /**
  //  * function to close the dropdown on click anywhere in window
  //  * @param e-targetting binded value to close drop down
  //  */
  // const onCloseCopyEmails = (e) => {
  //   if (emailArea && emailArea.contains(e.target) == false) {
  //     copyEmails = copyEmails.filter((email) => email.value)
  //   }
  // console.log(copyEmails)
  // }

  const generateHTMLMailContent = (bodyContent) => {
    return `<!DOCTYPE html>
<html>

<head>
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <style>
    .cardBody {
      width: auto;
      padding: 12px;
      margin-right: auto;
      margin-left: auto;
      margin-bottom: 20px;
      margin-top: 0px;
      word-break: break-word;
    }

    .link {
      background-color: #1a73e8!important;
      color: #ffffff!important;
      padding: 3px 15px;
      text-decoration: none;
      border-radius: 4px;
      display: inline-block;
    }

    .content {
      padding: 32px;
      color: #333!important;
      font-size: 13px;
      line-height: 1.6;
      padding-bottom: 8px;
    }

    .disclaimer {
      font-size: 12px;
      color: #888888!important;
      text-align: center;
      margin-top: 30px;
      margin-bottom: 0px;
    }

    .footer {
      padding: 16px 32px;
      background: #3b4049!important;
      color: rgba(255, 255, 255, 0.6)!important;
      font-size: 12px;
      text-align: center;
      border-bottom-right-radius: 5px;
      border-bottom-left-radius: 5px;
    }

    .footer img {
      width: 120px;
    }

    @media (min-width: 900px) {
      .cardBody {
        max-width: 850px;
        word-break: break-word;
      }
    }

    .innerContent {
      border-radius: 5px;
      color: #000000!important;
      background: #ffffff!important;
      overflow-wrap: break-word;
    }
  </style>
</head>

<body>
  <div id="htmlToImage" style="
        background: #f7f7f7; 
        padding-top: 60px; 
        padding-bottom: 30px; 
        font-family:Arial !important;
        border-radius: 6px">
    <div id="cardBody" class="cardBody">
      <div class="innerContent">
        <div class="content">
          ${bodyContent}
          <p class="disclaimer">This is an automated e-mail, kindly do not reply</p>
        </div>
        <div class="footer">
          Powered by<br>
          <img src="https://print2block.com/img/docchain.png" alt="Docchain Logo" />
        </div>
      </div>
    </div>
  </div>
</body>
</html>
  `
  }
</script>

<svelte:head>
  <title>Compose Email</title>
</svelte:head>

<!-- <svelte:window on:click={onCloseCopyEmails} /> -->

{#if showInvalidAttrModal}
  <SuggestionModal
    {parsedJson}
    editorValues={invalidAttributes}
    on:closeModal={() => {
      showInvalidAttrModal = false
    }}
    on:applyAndContinue={handleApplyContinue}
  />
{/if}

<div class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] pb-24 dark:bg-bodyblack">
  <Navbar />

  {#if loading}
    <LoadingScreen msg={loadtext} />
  {/if}

  {#if !showEmailTemplateSelection}
    <div class="px-6">
      <div class="mx-auto w-full max-w-[920px] pt-6">
        <div class="mx-auto w-full">
          <button
            on:click={() => {
              if (query.aliasId) push(`/documents/single/secure_access?id=${query.id}`)
              else if (query.badgeId) push(`/documents/badge/details?documentId=${query.id}&badgeId=${query.badgeId}`)
              else push(`/analytics/documents/single?id=${query.id}`)
            }}
            type="button"
            style="text-decoration: none;"
            class="mb-1 hidden w-16 cursor-pointer select-none text-base font-medium text-gray-200 hover:text-blue-600 focus-visible:text-blue-600 focus-visible:outline-none active:text-blue-500 sm:mb-0 md:block"
          >
            <span>
              <i class="fa-solid fa-reply" />
              <span>&nbsp;Back&nbsp;</span>
            </span>
          </button>
        </div>
        <div class="mx-auto">
          <div class="flex flex-col items-center justify-between gap-0 mobile:gap-3 md:flex-row">
            <div class="mx-auto mt-3 flex flex-col items-center justify-center mobile:mt-0 md:ml-0 md:items-start lg:mx-0">
              <div class="select-none text-xl font-bold text-black dark:text-white lg:text-2xl xl:text-2xl">Compose Email</div>
            </div>
            <div class="mt-3 flex items-center justify-center gap-3 md:mt-0">
              <div data-tooltip="Back to List" tooltip-position="top" class="block md:hidden">
                <button
                  type="button"
                  on:click={() => {
                    push(`/analytics/documents/single?id=${query.id}`)
                  }}
                  class="flex h-9 min-w-[36px] cursor-pointer items-center justify-center rounded-full border border-[#a0a1a580] bg-white px-2 text-sm font-medium text-gray-900 no-underline hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 dark:bg-lightgray dark:text-white dark:hover:bg-blue-600"
                >
                  <i class="fa-solid fa-reply" />
                </button>
              </div>

              <button disabled={disableEmailBtn || !emailSubject || !toAddress || (query.aliasId != undefined && !query.aliasId)} on:click={sendTestEmail} data-tooltip="Send Email" tooltip-position="top" class="flex h-9 w-9 items-center justify-center rounded-full border border-[#a0a1a580] bg-white px-2 text-sm font-medium text-gray-900 hover:bg-green-500 hover:text-white focus:outline-none disabled:cursor-not-allowed disabled:bg-[#f7f7f7] disabled:text-gray-900/50 dark:bg-lightgray dark:text-white dark:hover:bg-green-500 dark:disabled:text-gray-900 dark:disabled:hover:bg-transparent">
                <i class="fa-solid fa-envelope" />
              </button>
            </div>
          </div>
        </div>

        <div class="mt-3 flex pb-12 md:px-0">
          <div class="relative mx-auto h-full w-full rounded-md bg-white p-6 px-6 dark:bg-darkgray">
            <div class="relative w-full rounded-md bg-white dark:bg-darkgray">
              <div class="space-y-3">
                {#if query && !query.badgeId}
                  <div class="sm:grid sm:grid-cols-3 sm:items-start md:items-center">
                    <div class="mb-1 block select-none text-base font-medium text-gray-500 sm:mb-0">Email Template</div>
                    <div class="sm:col-span-2 sm:mt-0">
                      {#if emailTempName}
                        <div class="flex items-center justify-between sm:col-span-2 sm:mt-0">
                          <h1 class="py-2 pl-5 text-sm font-normal text-slate-800 dark:text-slate-200 mobile:text-base">{emailTempName}</h1>
                          <div class="flex items-center gap-3">
                            <button
                              on:click={() => {
                                emailData = {
                                  headerType: "empty", //text
                                  headerText: "Test User",
                                }
                                content = `<p>hi <strong>${documentData.recName}</strong><br><br>Your Blockchain secured document is available at <br>
        <a href="${baseURL}" target="_blank" rel="noreferrer" style="color:inherit; overflow-wrap: break-word;"><strong>${baseURL}</strong></a>
        </p>`
                                emailTempName = ""
                                emailSubject = ""
                                push(`/analytics/documents/send-email?id=${query.id}${query.aliasId ? `&aliasId=${query.aliasId}` : ``}`)
                              }}
                              type="button"
                              class="flex h-9 w-max min-w-[36px] select-none items-center justify-center rounded-md border border-transparent bg-red-500 px-2 text-sm font-medium text-white hover:bg-red-600 focus:outline-none active:bg-red-500 disabled:cursor-not-allowed disabled:bg-red-200"
                            >
                              remove
                            </button>
                            <button
                              on:click={() => {
                                showEmailTemplateSelection = true
                              }}
                              type="button"
                              class="flex h-9 w-max min-w-[36px] select-none items-center justify-center rounded-md border border-transparent bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-blue-200"
                            >
                              Change
                            </button>
                          </div>
                        </div>
                      {:else}
                        <button
                          on:click={() => {
                            showEmailTemplateSelection = true
                          }}
                          type="button"
                          class="flex h-9 w-full select-none items-center justify-center rounded-md border border-transparent bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-blue-200"
                        >
                          <span class="hidden sm:block">&nbsp;Choose Email Template</span>
                          <span class="block sm:hidden">&nbsp;Choose</span>
                        </button>
                      {/if}
                    </div>
                  </div>
                {/if}
                <div class="sm:grid sm:grid-cols-3 sm:items-start md:items-center">
                  <div class="mb-1 block select-none text-base font-medium text-gray-500 sm:mb-0">From</div>
                  <div class="sm:col-span-2 sm:mt-0">
                    <h1 class="py-2 pl-5 text-sm font-normal text-slate-800 dark:text-slate-200 mobile:text-base">
                      {$ApplicationState.pmEmail || "Docchain Documents <docs@support.print2block.in>"}
                    </h1>
                  </div>
                </div>
                <!-- <div bind:this={emailArea} class="mb-4 flex flex-col gap-3"> -->
                <div class="grid sm:grid-cols-3 sm:items-start md:items-center">
                  <div class="flex flex-col justify-between text-base font-medium text-gray-500 md:flex-row md:items-center md:gap-3">
                    <div class="mb-1 block select-none sm:mb-0">To [Send Email]</div>
                    <!-- {#if !copyEmails.length}
                    <div class="flex items-center gap-3 pr-3">
                      <button on:click|stopPropagation={() => (copyEmails = [...copyEmails, { type: "Cc", value: "" }])} class="cursor-pointer hover:underline">Cc</button>
                      <button on:click|stopPropagation={() => (copyEmails = [...copyEmails, { type: "Bcc", value: "" }])} class="cursor-pointer hover:underline">Bcc</button>
                    </div>
                  {/if} -->
                  </div>
                  <div class="flex h-full w-full sm:col-span-2 sm:mt-0">
                    <!-- svelte-ignore a11y-autofocus -->
                    <input required type="text" bind:value={toAddress} placeholder="Enter Email Address" class="block w-full appearance-none {copyEmails.length != 2 ? 'rounded-l-md' : 'rounded-md'} rounded-l-md border border-[#a0a1a580] bg-transparent px-3 py-2 pl-5 text-sm text-gray-800 placeholder-gray-200 outline-none invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:text-white" />
                    <!-- {#if !copyEmails.length} -->
                    {#if !copyEmails.filter((email) => email.type == "Cc").length}
                      <button data-tooltip="Add Cc recipients" tooltip-position="top" on:click|stopPropagation={() => (copyEmails = [...copyEmails, { type: "Cc", value: "" }])} class="aspect-square h-full cursor-pointer items-center justify-center border-y border-r border-[#a0a1a580] bg-transparent text-base font-medium text-gray-500 hover:text-blue-500 hover:underline dark:hover:text-white {copyEmails.length == 1 && !copyEmails.filter((email) => email.type == 'Cc').length ? 'rounded-r-md' : ''}">Cc</button>
                    {/if}
                    {#if !copyEmails.filter((email) => email.type == "Bcc").length}
                      <button data-tooltip="Add Bcc recipients" tooltip-position="top" on:click|stopPropagation={() => (copyEmails = [...copyEmails, { type: "Bcc", value: "" }])} class="aspect-square h-full cursor-pointer items-center justify-center border-y border-r border-[#a0a1a580] bg-transparent text-base font-medium text-gray-500 hover:text-blue-500 hover:underline dark:hover:text-white {!copyEmails.filter((email) => email.type == 'Bcc').length ? 'rounded-r-md' : ''}">Bcc</button>
                    {/if}
                    <!-- {/if} -->
                  </div>
                </div>

                {#each copyEmails as email}
                  <div class="grid sm:grid-cols-3 sm:items-start md:items-center">
                    <div class="flex flex-col justify-between text-base font-medium text-gray-500 md:flex-row md:items-center md:gap-3">
                      <div class="mb-1 block select-none sm:mb-0">{email.type == "Cc" ? "Cc" : "Bcc"}</div>
                      <!-- {#if copyEmails.length == 1}
                      <div class="flex items-center gap-3 pr-3">
                        <button
                          on:click|stopPropagation={() => {
                            if (email.type == "Cc") copyEmails = [...copyEmails, { type: "Bcc", value: "" }]
                            if (email.type == "Bcc") copyEmails = [...copyEmails, { type: "Cc", value: "" }]
                          }}
                          class="cursor-pointer hover:underline"
                        >
                          {email.type == "Cc" ? "Bcc" : "Cc"}
                        </button>
                      </div>
                    {/if} -->
                    </div>
                    <div class="flex h-full sm:col-span-2 sm:mt-0">
                      <!-- svelte-ignore a11y-autofocus -->
                      <input autofocus type="text" bind:value={email.value} placeholder="Enter Email Address" class="block w-full appearance-none rounded-l-md border border-[#a0a1a580] bg-transparent px-3 py-2 pl-5 text-sm text-gray-800 placeholder-gray-200 outline-none invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:text-white" />
                      <button data-tooltip="Close" tooltip-position="top" on:click|stopPropagation={() => (copyEmails = copyEmails.filter((emails) => emails.type != email.type))} class="flex aspect-square h-full cursor-pointer items-center justify-center rounded-r-md border-y border-r border-[#a0a1a580] bg-transparent text-base font-medium text-gray-500 hover:text-red-500"><i class="fa-solid fa-xmark" /></button>
                    </div>
                  </div>
                {/each}
                <!-- </div> -->
                <div class="sm:grid sm:grid-cols-3 sm:items-start md:items-center">
                  <div class="mb-1 block select-none text-base font-medium text-gray-500 sm:mb-0">Subject</div>
                  <div class="sm:col-span-2 sm:mt-0">
                    <input on:keypress={checkSpecialCharsSubject} on:paste={checkSpecialCharsSubject} on:paste={exceedsmaxCharacters} on:keypress={exceedsmaxCharacters} on:blur={checkEmptySubject} required type="text" bind:value={emailSubject} class="block w-full appearance-none rounded-md border border-[#a0a1a580] bg-transparent px-3 py-2 pl-5 text-sm text-gray-800 placeholder-gray-200 outline-none invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:text-white" placeholder="Subject of the mail" />
                  </div>
                </div>

                <div class="!mt-4 mobile:!mt-8 md:h-[60%] xl:h-[45%]">
                  <TextEditor {qrSource} bind:content {parsedJson} displayValue={true} color={emailData.cardBackground} />
                </div>

                <div class="flex justify-end gap-3">
                  <button disabled={disableEmailBtn || !emailSubject || !toAddress || (query.aliasId != undefined && !query.aliasId)} on:click={sendTestEmail} type="button" class="flex h-9 min-h-full min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-[#f7f7f7] px-3 py-1.5 text-sm font-medium text-gray-900 hover:bg-green-500 hover:text-white focus:outline-none disabled:cursor-not-allowed disabled:bg-[#f7f7f7]/50 disabled:text-gray-900/50 dark:bg-lightgray dark:text-white dark:hover:bg-green-500 dark:disabled:text-gray-900 dark:disabled:hover:bg-transparent sm:w-auto">
                    <span>
                      <i class="fa-solid fa-envelope" />
                    </span>
                    <span class="select-none">&nbsp;&nbsp;Send&nbsp;Email</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  {:else}
    <EmailSelection
      on:back={() => {
        showEmailTemplateSelection = false
      }}
      on:emailSelect={onEmailSelection}
    />
  {/if}
  <Footer />
</div>
